import React, { useState, useEffect, useContext } from 'react';
import { Tabs, Card, Button, Icon } from 'antd';
import { Context, useFetch } from 'store';
import { Select } from '_src/shared/form-helpers';
import { PersistentRepo } from '_src/shared/repo';
import services from '_src/services';

import { PageContainer, StyledCard, FiltersRow } from './styles';
import LaptopInventory from './components/LaptopInventory';
import LaptopLoansTable from './components/LaptopLoansTable';
import LaptopSettings from './components/LaptopSettings';

const { TabPane } = Tabs;

const locationsConfig = services['studentRecords'];

export default function LaptopLending() {
  const { getData } = useContext(Context);
  const user = getData('user');

  const [activeTab, setActiveTab] = useState('inventory');
  const [locations, setLocations] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const { get: getLocations } = useFetch({ ...locationsConfig.getLocations });

  useEffect(() => {
    getLocations().then(data => {
      if (data && Array.isArray(data)) {
        const branches = data.filter(item => item.type === 0);
        setLocations(branches);

        const savedLocation = PersistentRepo.get('location');
        if (savedLocation) {
          const [, , branchId] = savedLocation.split('x');
          setSelectedBranch(parseInt(branchId, 10));
        } else if (user?.branchId) {
          setSelectedBranch(user.branchId);
        } else if (branches.length > 0) {
          const [, , firstBranchId] = branches[0].id.split('x');
          setSelectedBranch(parseInt(firstBranchId, 10));
        }
      }
    });
  }, []);

  const handleBranchChange = (locationId) => {
    const [, , branchId] = locationId.split('x');
    setSelectedBranch(parseInt(branchId, 10));
  };

  return (
    <PageContainer>
      <StyledCard title="Laptop Lending Management">
        <FiltersRow>
          <Select
            label="Branch"
            showSearch
            value={locations.find(l => {
              const [, , branchId] = l.id.split('x');
              return parseInt(branchId, 10) === selectedBranch;
            })?.id}
            onChange={handleBranchChange}
            options={locations}
            style={{ width: 300 }}
          />
        </FiltersRow>

        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="Laptop Inventory" key="inventory">
            <LaptopInventory
              branchId={selectedBranch}
              branches={locations.map(loc => {
                const [, , branchId] = loc.id.split('x');
                return { id: parseInt(branchId, 10), name: loc.label };
              })}
            />
          </TabPane>

          <TabPane tab="All Loans" key="loans">
            <LaptopLoansTable branchId={selectedBranch} />
          </TabPane>

          <TabPane tab="Settings" key="settings">
            <LaptopSettings branchId={selectedBranch} />
          </TabPane>
        </Tabs>
      </StyledCard>
    </PageContainer>
  );
}
